<script>
  import Button from "./Button.svelte";
  import NamePrompt from "./NamePrompt.svelte";

  export let share
  let status;
  $: (async () => {
    let newStatus = await share.to_dict();
    if (JSON.stringify(newStatus) !== JSON.stringify(status)) {
      status = newStatus;
    }
  })()
</script>

<h3>
  Write
</h3>
{#each Object.entries(status || {}).filter(([_, v]) => v === 'write').map(([k, _]) => k) as name}
  <div style='display:flex'>
    <Button on:click={async () => {status = await share(name, 'read').to_dict()}} 
      >{'↓'}</Button>
    <p style='flex-grow: 1'>{name}</p>
    <Button on:click={async () => {status = await share.remove(name).to_dict()}}
      style='background-color: #fee;'
      >-</Button>
  </div>  
{/each}
<NamePrompt name='+' on:submit={async ({detail}) => {status = await share(detail, 'write').to_dict()}} />
<h3>
  Read
</h3>
{#each Object.entries(status || {}).filter(([_, v]) => v === 'read').map(([k, _]) => k) as name}
  <div style='display:flex'>
    <Button on:click={async () => {status = await share(name, 'write').to_dict()}}
      >{'↑'}</Button>
    <Button on:click={async () => {status = await share(name, 'execute').to_dict()}}
      >{'↓'}</Button>
    <p style='flex-grow: 1'>{name}</p>
    <div style='width: 30px'/>
    <Button on:click={async () => {status = await share.remove(name).to_dict()}}
      style='background-color: #fee;'
      >-</Button>
  </div>  
{/each}
<NamePrompt name='+' on:submit={async ({detail}) => {status = await share(detail, 'read').to_dict()}} />
<h3>
  Execute
</h3>
{#each Object.entries(status || {}).filter(([_, v]) => v === 'execute').map(([k, _]) => k) as name}
  <div style='display:flex'>
    <Button on:click={async () => {status = await share(name, 'read').to_dict()}}
      >{'↑'}</Button>
    <p style='flex-grow: 1'>{name}</p>
    <Button on:click={async () => {status = await share.remove(name).to_dict()}}
      style='background-color: #fee;'
      >-</Button>
  </div>  
{/each}
<NamePrompt name='+' on:submit={async ({detail}) => {status = await share(detail, 'execute').to_dict()}} />

<style>
</style>